import React from "react"
import "./hero.css"
import "./carousel.css"
import Wave from "../components/wave"
import { UncontrolledCarousel } from "reactstrap"

const EnvCarrusel = process.env.GATSBY_CARRUSEL
let carrusel = false

if (EnvCarrusel === "true") {
  carrusel = true
}

const Hero = ({ data }) => {
  if (!data) return null

  const items = []
  const carruselImages = data.imagenCarrusel || []
  carruselImages.forEach((item) => {
    if (item?.file?.url) {
      items.push({ src: item.file.url, altText: "", caption: "" })
    }
  })

  const imageUrl = data.imagenIntro?.file?.url
  const titulo = data.titulo || ""
  const subtitulo = data.subtitulo || ""
  const sloganText = data.slogan?.slogan || ""

  return carrusel && items.length > 0 ? (
    <div className="Hero">
      <UncontrolledCarousel
        items={items}
        autoPlay={true}
        pause={false}
        interval="5000"
      />
      <div className="HeroGroup">
        <div className="HeroGroupBack"> </div>
        <div className="HeroGroupTitle">
          <h1>{titulo}</h1>
          <h2>{subtitulo}</h2>
          <p>{sloganText}</p>
        </div>
      </div>
      <Wave position="bottom" />
    </div>
  ) : (
    <div className="Hero" style={{ backgroundImage: imageUrl ? `url(${imageUrl})` : undefined }}>
      <div className="HeroGroup">
        <div className="HeroGroupBack"> </div>
        <div className="HeroGroupTitle">
          <h1>{titulo}</h1>
          <h2>{subtitulo}</h2>
          <p>{sloganText}</p>
        </div>
      </div>
      <Wave position="bottom" />
    </div>
  )
}

export default Hero
